const engMonth = (mm)=> {
	mm = String(mm);
	if (mm == "1") return "January";
	else if (mm == "2") return "February";
	else if (mm == "3") return "March";
	else if (mm == "4") return "April";
	else if (mm == "5") return "May";
	else if (mm == "6") return "June";
	else if (mm == "7") return"July";
	else if (mm == "8") return "August";
	else if (mm == "9") return "September";
	else if (mm == "10") return "October";
	else if (mm == "11") return "November";
	else if (mm == "12") return "December";
};
const rusMonth = (mm)=> {
	mm = String(mm);
	if (mm == "1") return "января";
	else if (mm == "2") return "февраля";
	else if (mm == "3") return "марта";
	else if (mm == "4") return "апреля";
	else if (mm == "5") return "мая";
	else if (mm == "6") return "июня";
	else if (mm == "7") return"июля";
	else if (mm == "8") return "августа";
	else if (mm == "9") return "сентября";
	else if (mm == "10") return "октября";
	else if (mm == "11") return "ноября";
	else if (mm == "12") return "декабря";
};
const rusWeek = (ww)=> {
	ww = String(ww);
	if (ww == "1") return "1-я неделя";
	else if (ww == "2") return "2-я неделя";
	else if (ww == "3") return "3-я неделя";
	else if (ww == "4") return "4-я неделя";
	else if (ww == "5") return "5-я неделя";
};
const nepMonth = (mm)=> {
	mm = String(mm);
	if (mm == "1") return "ของเดือนมกราคม";
	else if (mm == "2") return "ของเดือนกุมภาพันธ์";
	else if (mm == "3") return "ของเดือนมีนาคม";
	else if (mm == "4") return "ของเดือนเมษายน";
	else if (mm == "5") return "ของเดือนพฤษภาคม";
	else if (mm == "6") return "ของเดือนมิถุนายน";
	else if (mm == "7") return "ของเดือนกรกฎาคม";
	else if (mm == "8") return "ของเดือนสิงหาคม";
	else if (mm == "9") return "ของเดือนกันยายน";
	else if (mm == "10") return "ของเดือนตุลาคม";
	else if (mm == "11") return "ของเดือนพฤศจิกายน";
	else if (mm == "12") return "ของเดือนธันวาคม";
};
const engWeek = (ww)=> {
	ww = String(ww);
	if (ww == "1") return "1st";
	else if (ww == "2") return "2nd";
	else if (ww == "3") return "3rd";
	else if (ww == "4") return "4th";
	else if (ww == "5") return "5th";
};
const lang = localStorage.getItem("lang");
const langCommon = {
	embedHdr:function() {
		var data = {
			kor:"",
			// kor:'https://fonts.googleapis.com/css2?family=Hi+Melody&display=swap', // font-family: 'Hi Melody', cursive;
			eng:'https://fonts.googleapis.com/css2?family=Hind+Siliguri:wght@400;500;700&display=swap', // font-family: 'Hind Siliguri', sans-serif;
			rus:'https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap',  // font-family: 'Balsamiq Sans', cursive;
			nep:'https://fonts.googleapis.com/css2?family=Kalam:wght@700&display=swap', // Kalam', cursive;
			tai:'https://fonts.googleapis.com/css2?family=Itim&display=swap', // font-family: 'Itim', cursive;
			mog:'https://fonts.googleapis.com/css2?family=Pangolin&display=swap', // font-family: 'Pangolin', cursive;
			bur:'https://fonts.googleapis.com/css2?family=Padauk:wght@400;700&display=swap',	// font-family: 'Padauk', sans-serif;
			kaz:'https://fonts.googleapis.com/css2?family=Balsamiq+Sans&display=swap',  // font-family: 'Balsamiq Sans', cursive;
		};
		return data[lang]?'<link href="'+data[lang]+'" rel="stylesheet">':'';
	},
	embedBody:function() {
		var data = {
			kor:"",
			// kor:'https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap', // font-family: 'Noto Sans KR', sans-serif;
			eng:'https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap', // font-family: 'Roboto', sans-serif;
			rus:'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap', // font-family: 'Open Sans', sans-serif;
			nep:'https://fonts.googleapis.com/css2?family=Hind&display=swap', // font-family: 'Hind', sans-serif;
			tai:'https://fonts.googleapis.com/css2?family=Krub:wght@400;700&display=swap', // font-family: 'Krub', sans-serif;
			mog:'https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;700&display=swap', // font-family: 'Source Sans Pro', sans-serif;
			bur:'https://fonts.googleapis.com/css2?family=Noto+Sans+Myanmar:wght@400;700&display=swap',	// font-family: 'Noto Sans Myanmar', sans-serif;
			kaz:'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap', // font-family: 'Open Sans', sans-serif;
		};
		return data[lang]?'<link href="'+data[lang]+'" rel="stylesheet">':'';
	},
	buildRoot:function(){
		var fontH={
			kor:"'Hi Melody', cursive",
			eng:"'Hind Siliguri', sans-serif",
			rus:"'Balsamiq Sans', cursive",
			nep:"'Kalam', cursive",
			tai:"'Itim', cursive",
			mog:"'Pangolin', cursive",
			bur:"'Padauk', sans-serif",
			kaz:"'Balsamiq Sans', cursive",
		}
		var fontB={
			kor:"'Noto Sans KR', sans-serif",
			eng:"'Roboto', sans-serif",
			rus:"'Open Sans', sans-serif",
			nep:"'Hind', sans-serif",
			tai:"'Krub', sans-serif",
			mog:"'Source Sans Pro', sans-serif",
			bur:"'Noto Sans Myanmar', sans-serif",
			kaz:"'Open Sans', sans-serif",
		}
		var str='<style>\n';
			str+=':root {\n';
			str+='--header-font:';
			str+=fontH[lang];
			str+=';\n';
			str+='--body-font:';
			str+=fontB[lang];
			str+=';\n';
			str+='}\n';
			str+='</style>\n';
		return str;
	},
	hibible:{
		kor:"하이바이블", eng:"Hi Bible", rus:"Привет Библия", nep:"बाइबल को बारेमा", tai:"Hi Bible", mog:'Сайн уу Библи', bur:'HiBible', kaz:'HiBible'
	},
	isoCode:{
		kor:"ko", eng:"en", rus:"ru", nep:"np", tai:"th", mog:'mn', bur:"mr", kaz:"kz"
	},
	nav:{
		episode:{
			kor:"성경 이야기", eng:"Episode", rus:"Episode", nep:"बाइबल कथाहरु", tai:"เรื่อง", mog:"Түүх", bur:"ပုံပြင်များ", kaz:"Әңгімелер"
		},
		data:{
			kor:"자료", eng:"Materials", rus:"материалы", nep:"सामाग्री", tai:"ข้อมูล", mog:"Гарын авлага", bur:"စာရွက်စာတမ်းများ", kaz:"материалдар"
		},
		bible:{
			kor:"징검다리 성경읽기", eng:"Stepping Stones, Bible Reading!", rus:"Пошаговые Действия", nep:"पत्थर पत्थर बाइबल पढाइ", tai:'อ่านพระคัมภีร์ "หินรองทางเดิน"', mog:"Гишгүүр чулуу, Библи уншлага", bur:"ကျောက်တုံးတံတား ကျမ်းစာဖတ်ခြင်း", kaz:"Киелі қітапті қадаммен оқу"
		},
		about:{
			kor:"하이바이블", eng:"About HiBible", rus:"о Hi Bible(Привет Библия)", nep:"नमस्ते बाइबल को बारेमा", tai:"แนะนํา HiBible", mog:'"Сайн уу Библи" ийн тухай', bur:"HiBible မိတ်ဆက်", kaz:"HiBible туралы"
		},
		language:{
			kor:"언어설정", eng:"Language setting", rus:"язык", nep:"भाषा सेटि", tai:"ภาษา", mog:"Хэлний тохиргоо", bur:"ဘာသာစကား ချိန်ညှိမှု", kaz:"Тілі"
		}
	},
	pageHeader:{
		episode:{
			main:{
				kor:"성경이야기", eng:"Hi.Bible", rus:"Hi.Bible", nep:"बाइबल", tai:"คัมภีร์ไบเบิล", mog:"Сайн уу Библи", bur:"Hi.Bible", kaz:"Hi.Bible"
			},
			sub:{
				kor:"stories", eng:"stories", rus:"проповеди", nep:"कथाहरु", tai:"เรื่อง", mog:"Түүх", bur:"ပုံပြင်များ", kaz:"Әңгімелер"
			}
		},
		data:{
			main:{
				kor:"하이바이블 자료들", eng:"Materials", rus:"о Hi Bible", nep:"सामाग्री", tai:"ข้อมูล", mog:"Сайн уу Библи", bur:"Hi.Bible", kaz:"Hi.Bible"
			},
			sub:{
				kor:"activity materials", eng:"", rus:"материалы", nep:"data", tai:"data", mog:"Гарын авлага", bur:"စာရွက်စာတမ်းများ", kaz:"материалдар"
			}
		},
		bible:{
			main:{
				kor:"징검다리 성경읽기", eng:"Stepping Stones, Bible Reading!", rus:"Пошаговые Действия", nep:"पत्थर पत्थर बाइबल पढाइ", tai:'อ่านพระคัมภีร์ "หินรองทางเดิน"', mog:"Гишгүүр чулуу, Библи уншлага", bur:"ကျောက်တုံးတံတား ကျမ်းစာဖတ်ခြင်း", kaz:"Киелі қітапті қадаммен оқу"
			},
			sub:{
				kor:"", eng:"", rus:"", nep:"", tai:"", mog:"", bur:"", kaz:""
			}
		},
		about:{
			main:{
				kor:"소개", eng:"About Hi.Bible", rus:"Пошаговые Действия", nep:"बारेम नमस्ते बाइबल", tai:"แนะนํา HiBible", mog:'"Сайн уу Библи" ийн тухай', bur:"HiBible မိတ်ဆက်", kaz:"HiBible туралы"
			},
			sub:{
				kor:"", eng:"", rus:"", nep:"", tai:"", mog:"", bur:"", kaz:""
			}
		}
	},
	dateForm : function(yyyy,mm,ww) {
		var data={
			kor:"YYYY년 MM월 WW주", eng:"WW week of MM, YYYY", rus:"WW MM YYYY г.", nep:"สัปดาห์ที่ WW MM YYYY", tai:"อาทิตยที่WW เดือนMM ปีYYYY", mog:"YYYYон MMсар WWдолоо хоног", bur:"YYYYနှစ် MMလ WWအပတ်", kaz:"YYYY жыл MM-ай  WW-апта"
		};
		if (lang == "eng") return data[lang].split("YYYY").join(yyyy).split("MM").join(engMonth(mm)).split("WW").join(engWeek(ww));
		else if (lang == "rus") return data[lang].split("YYYY").join(yyyy).split("MM").join(rusMonth(mm)).split("WW").join(rusWeek(ww));
		else if (lang == "nep") return data[lang].split("YYYY").join(yyyy).split("MM").join(nepMonth(mm)).split("WW").join(ww);
		else return data[lang].split("YYYY").join(yyyy).split("MM").join(mm).split("WW").join(ww);
	},
	weekForm : function(ww) {
		var data={
			kor:"WW주", eng:"WW week", rus:"WW неделя", nep:"สัปดาห์ที่ WW", tai:"อาทิตยที่WW", mog:"WWдолоо хоног", bur:"WWအပတ်", kaz:"WW-апта"
		};
		if (lang == "eng") return data[lang].split("WW").join(engWeek(ww));
		else if (lang == "rus") return data[lang].split("WW").join(rusWeek(ww));
		else return data[lang].split("WW").join(ww);
	},
	bibles:{
		kor:["창세기", "출애굽기", "레위기", "민수기", "신명기", "여호수아", "사사기", "롯기", "사무엘상", "사무엘하", "열왕기상", "열왕기하", "역대상", "역대하", "에스라", "느헤미야", "에스더", "욥기", "시편", "잠언", "전도서", "아가", "이사야", "예레미야", "예레미야애가", "에스겔", "다니엘", "호세아", "요엘", "아모스", "오바댜", "요나", "미가", "나훔", "하박국", "스바냐", "학개", "스가랴", "말라기", "마태복음", "마가복음", "누가복음", "요한복음", "사도행전", "로마서", "고린도전서", "고린도후서", "갈라디아서", "에베소서", "빌립보서", "골로새서", "데살로니가전서", "데살로니가후서", "디모데전서", "디모데후서", "디도서", "빌레몬서", "히브리서", "야고보서", "베드로전서", "베드로후서", "요한일서", "요한이서", "요한삼서", "유다서", "요한계시록"],
		eng:["Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy", "Joshua", "Judges", "Ruth", "1 Samuel", "2 Samuel", "1 Kings", "2 Kings", "1 Chronicles", "2 Chronicles", "Ezra", "Nehemiah", "Esther", "Job", "Psalms", "Proverbs", "Ecclesiastes", "Song of Songs", "Isaiah", "Jeremiah", "Lamentations", "Ezekiel", "Daniel", "Hosea", "Joel", "Amos", "Obadiah", "Jonah", "Micah", "Nahum", "Habakkuk", "Zephaniah", "Haggai", "Zechariah", "Malachi", "Matthew", "Mark", "Luke", "John", "Acts", "Romans", "1 Corinthians", "2 Corinthians", "Galatinas", "Ephesians", "Philippians", "Colossians", "1 Thessalonians", "2 Thessalonians", "1 Timothy", "2 Timothy", "Titus", "Philemon", "Hebrews", "James", "1 Peter", "2 Peter", "1 John", "2 John", "3 John", "Jude", "Revelation"],
		nep:["उत्पत्ति", "प्रस्थान", "लेवी", "गन्ती", "व्यवस्था", "यहोशू", "न्यायकर्ता", "रूथ", "शमूएल एक", "शमूएल दुई", "राजा एक", "राजा दुई", "इतिहास एक", "इतिहास दुई", "एज्रा", "नहेम्याह", "एस्तर", "अय्यूब", "भजनसंग्रह", "हितोपदेश", "उपदेशक", "श्रेष्ठगीत", "यशैया", "यर्मिया", "विलाप", "इजकिएल", "दानियल", "होशे", "योएल", "आमोस", "ओबदिया", "योना", "मीका", "नहूम", "हबकूक", "सपन्याह", "हाग्गै", "जकरिया", "मलाकी", "मत्ती", "मर्कूस", "लूका", "यूहन्ना", "प्रेरित", "रोमी", "कोरिन्थी एक", "कोरिन्थी दुई", "गलाती", "एफिसी", "फिलिप्पी", "कलस्सी", "थिस्सलोनिकी एक", "थिस्सलोनिकी दुई", "तिमोथी एक", "तिमोथी दुई", "तीतस", "फिलेमोन", "हिब्रू", "याकूब", "पत्रुस एक", "पत्रुस दुई", "यूहन्ना एक", "यूहन्ना दुई", "यूहन्ना तीन", "यहूदा", "प्रकाश"],
		rus:["Бытие", "Исход", "Левит", "Числа", "Второзаконие", "Книга Иисуса Навина", "Книга Судей Израилевых", "Книга Руфи", "Первая книга Царств", "Вторая книга Царств", "Третья книга Царств", "Четвертая книга Царств", "Первая книга Паралипоменон", "Вторая книга Паралипоменон", "Первая книга Ездры", "Книга Неемии", "Книга Эсфири", "Книга Иова", "Псалтирь", "Книга Притчей Соломоновых", "Книга Екклесиаста, или Проповедника", "Книга Песни Песней Соломона", "Книга пророка Исаии", "Книга пророка Иеремии", "Книга Плач Иеремии", "Книга пророка Иезекииля", "Книга пророка Даниила", "Книга пророка Осии", "Книга пророка Иоиля", "Книга пророка Амоса", "Книга пророка Авдия", "Книга пророка Ионы", "Книга пророка Михея", "Книга пророка Наума", "Книга пророка Аввакума", "Книга пророка Софонии", "Книга пророка Аггея", "Книга пророка Захарии", "Книга пророка Малахии", "Евангелие от Матфея", "Евангелие от Марка", "Евангелие от Луки", "Евангелие от Иоанна", "Деяния Святых Апостолов", "Послание к Римлянам", "Первое Послание к Коринфянам", "Второе Послание к Коринфянам", "Послание к Галатам", "Послание к Ефесянам", "Послание к Филиппийцам", "Послание к Колоссянам", "Первое Послание к Фессалоникийцам", "Второе Послание к Фессалоникийцам", "Первое Послание к Тимофею", "Второе Послание к Тимофею", "Послание к Титу", "Послание к Филимону", "Послание к Евреям", "Послание Иакова", "Первое Послание Петра", "Второе Послание Петра", "Первое Послание Иоанна", "Второе Послание Иоанна", "Третье Послание Иоанна", "Послание Иуды", "Откровение Иоанна Богослова"],
		tai:["ปฐม‍กาล", "อพยพ", "เลวี‌นิติ", "กัน‌ดาร‍วิถี", "เฉลย‍ธรรม‍บัญ‌ญัติ", "โย‌ชู‌วา", "ผู้‍วินิจ‌ฉัย", "นาง​รูธ", "1 ซา‌มู‌เอล", "2 ซา‌มู‌เอล", "1 พงศ์‍กษัตริย์", "2 พงศ์‍กษัตริย์", "1 พง‌ศาว‌ดาร", "2 พง‌ศาว‌ดาร", "เอส‌รา", "เนหะมีย์", "เอส‌เธอร์", "โยบ", "สดุดี", "สุภา‌ษิต", "ปัญ‌ญา‌จารย์", "เพลง‍ซา‌โล‌มอน", "อิส‌ยาห์", "เย‌เร‌มีย์", "เพลง‍คร่ำ‍ครวญ", "เอ‌เส‌เคียล", "ดา‌เนียล", "โฮ‌เช‌ยา", "โย‌เอล", "อา‌โมส", "โอบาดีห์", "โย‌นาห์", "มี‌คาห์", "นา‌ฮูม", "ฮา‌บา‌กุก", "เศ‌ฟัน‌ยาห์", "ฮัก‌กัย", "เศ‌คา‌ริ‌ยาห์", "มา‌ลา‌คี", "มัท‌ธิว", "มา‌ระ‌โก", "ลูกา", "ยอห์น", "กิจการ​ของ​อัครทูต", "โรม", "1 โค‌รินธ์", "2 โค‌รินธ์", "กา‌ลา‌เทีย", "เอ‌เฟ‌ซัส", "ฟีลิปปี", "โค‌โล‌สี", "1 เธสะ‌โล‌นิ‌กา", "2 เธสะ‌โล‌นิ‌กา", "1 ทิ‌โม‌ธี", "2 ทิ‌โม‌ธี", "ทิตัส", "ฟี‌เล‌โมน", "ฮีบรู", "ยา‌กอบ", "1 เป‌โตร", "2 เป‌โตร", "1 ยอห์น", "2 ยอห์น", "3 ยอห์น", "จด‍หมาย​ของ ยูดา", "วิวรณ์",],
		mog:["Эхлэл", "Гэтлэл", "Левит", "Тооллого", "Дэд Хууль", "Иошуа", "Шүүгчид", "Рут", "1 Самуел", "2 Самуел", "Хаадын Дээд", "Хаадын Дэд", "Шастирын Дээд", "Шастирын Дэд", "Езра", "Нехемиа", "Естер", "Иов", "Дуулал", "Сургаалт Үгс", "Номлогчийн Үгс", "Соломоны Дуун", "Исаиа", "Иеремиа", "Иеремиагийн гашуудал", "Езекиел", "Даниел", "Хосеа", "Иоел", "Амос", "Обадиа", "Иона", "Мика", "Нахум", "Хабаккук", "Зефаниа", "Хаггаи", "Зехариа", "Малахи", "Матай", "Марк", "Лук", "Иохан", "Үйлс", "Ром", "1 Коринт", "2 Коринт", "Галат", "Ефес", "Филиппой", "Колоссай", "1 Тесалоник", "2 Тесалоник", "1 Тимот", "2 Тимот", "Тит", "Филемон", "Еврей", "Иаков", "1 Петр", "2 Петр", "1 Иохан", "2 Иохан", "3 Иохан", "Иуда", "Илчлэлт"],
		bur:["ကမ္ဘာဉီးကျမ်း", "ထွက်မြောက်ကျမး", "ဝတ်ပြုရာကျမး", "တောလည်ရာကျမး", "‌‌‌‌‌တရား‌‌‌‌ဟောရာကျမး", "‌‌ယောရှုမှတ်စာ", "‌‌တရားသူကြီးမှတ်စာ", "‌‌ရုသဝတ", "ဓမ္မရာဇဝင်ပဌမစောင", "ဓမ္မရာဇဝင်ဒုတိယစောင", "ဓမ္မရာဇဝင်တတိယစောင", "ဓမ္မရာဇဝင်စတုတ္ထစောင", "ရာဇဝင်ချုပ်ပဌမစောင", "ရာဇဝင်ချုပ်ဒုတိယစောင", "ဧဇရမှတ်စာ", "နေဟမိမှတ်စာ", "ဧသတာဝတ", "ယောဘဝတ", "ဆာလံကျမး", "သုတ္တံကျမး", "‌‌ဒေသနာကျမး", "ရှောလမုန်သီချငး", "‌ဟေရှာယအနာဂတ္တိကျမး", "‌ယေရမိအနာဂတ္တိကျမး", "ယေရမိမြည်တမ်းစကားး", "ယေဇကျေလအနာဂတ္တိကျမး", "ဒံယေလအနာဂတ္တိကျမး", "‌ဟော‌ရှေအနာဂတ္တိကျမး", "‌ယောလအနာဂတ္တိကျမး", "အာမုတ်အနာဂတ္တိကျမး", "သြဗဒိဗျာဒိတ်ရူပါရုံ", "ယောနဝတ", "မိက္ခာအနာဂတ္တိကျမး", "နာဟုံအနာဂတ္တိကျမး", "ဟဗက္ကုတ်အနာဂတ္တိကျမး", "ဇေဖနိအနာဂတ္တိကျမး", "ဟဂ္ဂဲအနာဂတ္တိကျမး", "ဇာခရိအနာဂတ္တိကျမး", "မာလခိအနာဂတ္တိကျမ်း", "ရှင်မဿဲခရစ်ဝင်", "ရှင်မာကုခရစ်ဝင်", "ရှင်လုကာခရစ်ဝင်", "ရှင်ယောဟန်ခရစ်ဝင်", "တမန်တော်ဝတ္ထု", "ရောမသြဝါဒစာ", "ကောရိန္သုသြဝါဒစာပဌမစောင်", "ကောရိန္သုသြဝါဒစာဒုတိယစောင်", "ဂလာတိသြဝါဒစာ", "ဧဖက်သြဝါဒစာ", "ဖိလိပ္ပိသြဝါဒစာ", "ကောလောသဲသြဝါဒစာ", "သက်သာလောနိတ်သြဝါဒစာပဌမစောင်", "သက်သာလောနိတ်သြဝါဒစာဒုတိယစောင်", "တိမောသေသြဝါဒစာပဌမစောင်", "တိမောသေသြဝါဒစာဒုတိယစောင်", "တိတုသြဝါဒစာ", "ဖိလေမုန်သြဝါဒစာ", "ဟေဗြဲသြဝါဒစာ", "ရှင်ယာကုပ်သြဝါဒစာ", "ရှင်ပေတရုသြဝါဒစာပဌမစောင်", "ရှင်ပေတရုသြဝါဒစာဒုတိယစောင်", "ရှင်ယောဟန်သြဝါဒစာပဌမစောင်", "ရှင်ယောဟန်သြဝါဒစာဒုတိယစောင်", "ရှင်ယောဟန်သြဝါဒစာတတိယစောင်", "ရှင်ယုဒသြဝါဒစာ", "ဗျာဒိတ်ကျမ်း"],
		kaz:["Жаратылыстың басталуы", "Мысырдан көшіп шығу", "Леуіліктер", "Руларды санау", "Заңды қайталау", "Ешуа", "Билер", "Рут", "Патшалықтар туралы 1-нші жазба", "Патшалықтар туралы 2-нші жазба", "Патшалықтар туралы 3-нші жазба", "Патшалықтар туралы 4-нші жазба", "Шежірелер туралы 1-нші жазба", "Шежірелер туралы 2-нші жазба", "Езра", "Нехемия", "Естер", "Әйүп", "Забур жырлары", "Нақыл сөздер", "Даналықты уағыздаушы", "Сүлейменнің таңдаулы әні", "Ишая пайғамбар", "Еремия пайғамбар", "Еремияның жоқтауы", "Езекиел пайғамбар", "Даниял пайғамбар", "Ошия пайғамбар", "Жоел пайғамбар", "Амос пайғамбар", "Абди пайғамбар", "Жүніс пайғамбар", "Миха пайғамбар", "Нақұм пайғамбар", "Аббақұқ пайғамбар", "Софония пайғамбар", "Хаққай пайғамбар", "Зәкәрия пайғамбар", "Малахи пайғамбар", "Матай жазған Ізгі хабар", "Марқа жазған Ізгі хабар", "Лұқа жазған Ізгі хабар", "Жохан жазған Ізгі хабар", "Елшілердің істері", "Римдіктерге арналған хат", "Қорынттықтарға арналған 1-нші хат", "Қорынттықтарға арналған 2-нші хат", "Ғалаттықтарға арналған хат", "Ефестіктерге арналған хат", "Філіпіліктерге арналған хат", "Қолостықтарға арналған хат", "Салониқалықтарға арналған 1-нші хат", "Салониқалықтарға арналған 2-нші хат", "Тімотеге арналған 1-нші хат", "Тімотеге арналған 2-нші хат", "Титке арналған хат", "Філимонға арналған хат", "Еврейлерге арналған хат", "Жақыптың хаты", "Петірдің 1-нші хаты", "Петірдің 2-нші хаты", "Жоханның 1-нші хаты", "Жоханның 2-нші хаты", "Жоханның 3-нші хаты", "Яһуданың хаты", "Аян"],
	},
	bibleForm:{
		kor:'<span class="info_book_name">BBBB</span> <span class="info_book_chapter">CCCC</span>:<span class="info_book_verse_s">SSSS</span>-<span class="info_book_verse_e">EEEE</span>',
		eng:'<span class="info_book_name">BBBB</span> Chapter <span class="info_book_chapter">CCCC</span>, Verse <span class="info_book_verse_s">SSSS</span>-<span class="info_book_verse_e">EEEE</span>',
		rus:'<span class="info_book_name">BBBB</span> <span class="info_book_chapter">CCCC</span>:<span class="info_book_verse_s">SSSS</span>-<span class="info_book_verse_e">EEEE</span>',
		nep:'<span class="info_book_name">BBBB</span> <span class="info_book_chapter">CCCC</span>:<span class="info_book_verse_s">SSSS</span>-<span class="info_book_verse_e">EEEE</span>',
		tai:'<span class="info_book_name">BBBB</span> <span class="info_book_chapter">CCCC</span>:<span class="info_book_verse_s">SSSS</span>-<span class="info_book_verse_e">EEEE</span>',
		mog:'<span class="info_book_name">BBBB</span> <span class="info_book_chapter">CCCC</span> бүлэг <span class="info_book_verse_s">SSSS</span> ишлэл ~ <span class="info_book_verse_e">EEEE</span> илшлэл',
		bur:'<span class="info_book_name">BBBB</span> အခန်း<span class="info_book_chapter">CCCC</span> အခန်းငယ်<span class="info_book_verse_s">SSSS</span> ~ အပိုဒ်<span class="info_book_verse_e">EEEE</span>',
		kaz:'<span class="info_book_name">BBBB</span> <span class="info_book_chapter">CCCC</span> тарау <span class="info_book_verse_s">SSSS</span>-<span class="info_book_verse_e">EEEE</span>  аяттар',
	},
	bibleStr:{
		kor:'BBBB CCCC:SSSS-EEEE',
		eng:'BBBB CCCC:SSSS-EEEE',
		rus:'BBBB CCCC:SSSS-EEEE',
		nep:'BBBB CCCC:SSSS-EEEE',
		tai:'BBBB CCCC:SSSS-EEEE',
		mog:'BBBB CCCC бүлэг SSSS ишлэл ~ EEEE илшлэл',
		bur:'BBBB CCCC:SSSS-EEEE',
		kaz:'BBBB CCCC:SSSS-EEEE',
	},
	bibleChapter:function(chapter) {
		let multi =  (chapter.split("-").length >1 || chapter.split("~").length >1 ) ? true : false, data;
		if (multi) {
			data = {
				kor:chapter+"장", eng:"Chapters "+chapter, rus:"Глава "+chapter, nep:"अध्याय "+chapter, tai:"บทที่ "+chapter, mog:chapter+"-р бүлэг", bur:"အခန်း"+chapter, kaz:chapter+" тарау"
			}
		} else {
			data = {
				kor:chapter+"장", eng:"Chapter "+chapter, rus:"Главы "+chapter, nep:"अध्याय "+chapter, tai:"บทที่ "+chapter, mog:chapter+"-р бүлэг", bur:"အခန်း"+chapter, kaz:chapter+" тарау"
			}
		}
		return data[lang];
	},
	fileTypeName:{
		drw:{
			kor:"색칠공부", eng:"Coloring", rus:"Раскраска", nep:"Coloring", tai:"ระบายสี", mog:"Өнгөөр будах", bur:"အရောင်ခြယ်ခြင်း", kaz:"Бояулар"
		},
		act:{
			kor:"활동자료", eng:"After worship activity", rus:"Активность после богослужения", nep:"After worship activity", tai:"After worship activity", mog:"Мөргөлийн дараах хөтөлбөр", bur:"After worship activity", kaz:"Cиынудан кейінгі әрекеттер"
		}
	},
	previewTitle:{
		kor:"하이바이블 자료 보기", eng:"View Hibible file", rus:"View Hibible file", nep:"View Hibible file", tai:"View Hibible file", mog:"View Hibible file", bur:"ဉပမာ", kaz:"Көру"
	},
	filePreview:function() {
		var data = {
			kor:"보기", eng:"View", rus:"Просмотр", nep:"फाइल हेर्नुहोस्", tai:"คลิปวิดีโอ", mog:"Жишээ", bur:"ဉပမာ", kaz:"Көру"
		}
		return data[lang];
	},
	fileDownload:function() {
		var data = {
			kor:"다운로드", eng:"Download", rus:"Скачать", nep:"डाउनलोड", tai:"ดาวน์โหลด", mog:"Татах", bur:"ဒေါင်းလုပ်ရယူခြင်း", kaz:"Жүктеп алу"
		}
		return data[lang];
	}
}
export default langCommon
